import React, { useEffect } from 'react';
import { ChannelName, ChannelProfileImage } from '../ChannelProfileInfo';
import './forwardFooter.scss';
import { deleteChannelSelection, resetChannelSelection, useSelectedChannels } from '../../../slice';
import { useDispatch } from 'react-redux';
import { handleForwardMessage } from '../../utils';

function ForwardFooter() {
    const dispatch = useDispatch();
    const selectedChannelData = useSelectedChannels();
    const selectedChannelIds = Object.keys(selectedChannelData);

    useEffect(() => {
        return () => dispatch(resetChannelSelection());
    }, []);

    const handleRemove = id => {
        const channel = selectedChannelData[id];
        if (!channel) return;
        dispatch(deleteChannelSelection(channel));
    };

    return (
        <div className="forward-footer">
            <div className="forward-footer-badges">
                {selectedChannelIds.map(id => {
                    const channel = selectedChannelData[id] || {};
                    return (
                        <div key={id} className="channel-badge" title={channel.name || ''}>
                            <ChannelProfileImage channelId={id} className="channel-image-sm" />
                            <span className="channel-badge-name">
                                <ChannelName channelId={id} asText />
                            </span>
                            <button
                                type="button"
                                className="channel-badge-remove"
                                aria-label={`Remove ${channel.name || ''}`}
                                onClick={e => {
                                    e.stopPropagation();
                                    handleRemove(id);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                >
                                    <path
                                        d="M3.33301 12.6673L12.6663 3.33398"
                                        stroke="#595959"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                    <path
                                        d="M12.6663 12.6673L3.33301 3.33398"
                                        stroke="#595959"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </button>
                        </div>
                    );
                })}
            </div>
            {selectedChannelIds.length > 0 && (
                <button className="forward-footer-icon" onClick={handleForwardMessage}>
                    Send
                </button>
            )}
        </div>
    );
}

export default ForwardFooter;
